import { render, staticRenderFns } from "./FeatureRow.vue?vue&type=template&id=fa8f1264&"
import script from "./FeatureRow.vue?vue&type=script&lang=js&"
export * from "./FeatureRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports